var _excluded = ["className", "cols", "xs", "sm", "md", "lg", "xl"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef } from "react";
import "./ALayout.scss";
var ACol = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var propsClassName = _ref.className,
    cols = _ref.cols,
    xs = _ref.xs,
    sm = _ref.sm,
    md = _ref.md,
    lg = _ref.lg,
    xl = _ref.xl,
    rest = _objectWithoutProperties(_ref, _excluded);
  var className = "a-col";
  if (cols) {
    className += " a-col-".concat(cols);
  }
  if (xs) {
    className += " a-colxs-".concat(xs);
  }
  if (sm) {
    className += " a-colsm-".concat(sm);
  }
  if (md) {
    className += " a-colmd-".concat(md);
  }
  if (lg) {
    className += " a-collg-".concat(lg);
  }
  if (xl) {
    className += " a-colxl-".concat(xl);
  }
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    ref: ref,
    className: className
  }));
});
ACol.propTypes = {
  /**
   *  Sets the number of columns to span.
   */
  cols: PropTypes.oneOf(["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "auto"]),
  /**
   *  Sets the number of columns to span at the xs breakpoint.
   */
  xs: PropTypes.oneOf(["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]),
  /**
   *  Sets the number of columns to span at the sm breakpoint.
   */
  sm: PropTypes.oneOf(["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]),
  /**
   *  Sets the number of columns to span at the md breakpoint.
   */
  md: PropTypes.oneOf(["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]),
  /**
   *  Sets the number of columns to span at the lg breakpoint.
   */
  lg: PropTypes.oneOf(["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]),
  /**
   *  Sets the number of columns to span at the xl breakpoint.
   */
  xl: PropTypes.oneOf(["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"])
};
ACol.displayName = "ACol";
export default ACol;